import { Component, OnInit } from '@angular/core';
import { User } from 'app/model/user.model';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from 'app/services/auth.service';
import { isHK } from 'app/app.component';
import { AnalysisService } from 'app/services/analysis.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {

  model = new User();
  submitted = false;
  constructor(
    private router: Router,
    private authService: AuthService,
    private analysisService: AnalysisService) {
    // this.authService.login();
  }

  ngOnInit() {
    // console.log('on init');
  }

  getIsHK(): boolean {
    return isHK;
  }

  signIn() {
    const __this__ = this;
    this.authService.signIn(this.model.email, this.model.password)
      .then((user) => {
        // reset
        __this__.analysisService.resetPolygons();
        __this__.router.navigate(['/main']);
      })
      .catch((error) => {
        this.model.email = '';
        this.model.password = '';
        this.authService.superUser = false;
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorMessage);
      });
  }

  onSubmit() {
    this.submitted = true;
    this.signIn()
  }

  cancel() {
    this.router.navigate(['/main']);
  }

  wyloguj() {
    // this.authService.logout();
    // this.authService.login();
    this.analysisService.resetPolygons();
    this.authService.superUser = false;
    this.authService.admin = false;
    this.router.navigate(['/main']);
  }

  isSU() {
    return this.authService.superUser;
  }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/auth/auth.component.ts